/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader } from '../../Modal';
import Form from '../../Form';
import useForm from '../../../hooks/useForm';
import { isEmpty } from '../../../utils/lodashExtend';
import { addTaxProd, editTaxProd } from '../../../apis/tax-portal/billing';
import { toast } from '../../../utils/toast';
import { restoreComma } from '../../../utils/validator/comma';

const defaultForm = {
  title: "",
  memo: "",
  supplyAmt: "0",
  taxAmt: "0",
  totalAmt: "0",
};

const TaxProd = (props) => {
  const { open, setOpen, submit, selectedItem, setSelectedItem } = props;

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    submit && submit();
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };
  const [fields] = useState([

    [
      {
        key: "title",
        title: "상품명",
        type: "input",
        required: true,
      },
    ],
    [
      {
        title: "공급가액",
        key: "supplyAmt",
        type: "input",
        validators: ['comma'],
      },
      {
        title: "부가세",
        key: "taxAmt",
        type: "input",
        validators: ['comma'],
      },
      {
        title: "금액",
        key: "totalAmt",
        type: "input",
        validators: ['comma'],
      },
    ],

    [
      {
        key: "memo",
        title: "메모",
        type: "textarea",
      },
    ]
  ]);

  const [mode, setMode] = useState("create");

  const _submit = (form) => {
    if (mode === "create") {
      addTaxProd(form)
        .then(res => {
          toast.success("등록이 완료되었습니다.");
          cancel();
        }).catch((e) => console.error(e));
    } else {
      editTaxProd(selectedItem.idx, form)
        .then(res => {
          toast.success("수정이 완료되었습니다.");
          cancel();
        }).catch((e) => console.error(e));
    }

  };


  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setValidateFields,
    setOriginForm,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    const supplyAmt = +restoreComma(form?.supplyAmt);
    const taxAmt = Math.max(Math.floor(supplyAmt * 0.1), 0) + "";
    setForm({
      taxAmt,
    });

  }, [form && form.supplyAmt]);
  useEffect(() => {
    const supplyAmt = +restoreComma(form?.supplyAmt);
    const taxAmt = +restoreComma(form.taxAmt);
    setForm({
      totalAmt: supplyAmt + taxAmt
    });
  }, [form && form.taxAmt]);

  useEffect(() => {
    const totalAmt = +restoreComma(form?.totalAmt);
    const supplyAmt = Math.ceil(totalAmt / 1.1);
    const taxAmt = totalAmt - supplyAmt;
    setForm({
      supplyAmt,
      taxAmt
    });
  }, [form && form.totalAmt]);

  useEffect(() => {
    if (!isEmpty(fields)) setValidateFields(fields);
  }, [fields]);


  useEffect(() => {
    setMode(selectedItem ? 'detail' : 'create');
    if (selectedItem) {
      setForm(selectedItem);
      setOriginForm(selectedItem);
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }

  }, [open, selectedItem]);
  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
      >
        <ModalHeader>
          {`세무상품 ${mode === "create" ? "등록" : "수정"}`}
        </ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === "create" ? "등록" : "수정"}
          submit={handleSubmit}
          cancel={cancel}
        />
      </Modal>
    </>
  );
};

export default TaxProd;